function LocationNumber(props) {
    return (
        <>
            <p><b>Sted</b></p>
            <select value={props.category} onChange={(e) => { props.setCategory(e.target.value) }}>
                <option value="none" disabled hidden>Velg sted</option>
                <option value="Øvre del">Øvre del</option>
                <option value="Nedre del">Nedre del</option>
                <option value="Grupperom">Grupperom</option>
            </select>
            <p><b>Nummer</b></p>
            <input value={props.number} onKeyDown={(e) => {if(e.key === "Enter") {props.updateQRCodeList?.()}}} onChange={(e) => { props.setNumber(e.target.value) }} placeholder="Nummer" type="number" inputMode="numeric" />
        </>
    );
};

export default LocationNumber;